export const RD_PAYROLL_UPLOAD_TEMPLATE_KEY = 'rd-payroll-upload-v1';
export const RIPPLING_PAYROLL_UPLOAD_TEMPLATE_KEY = 'rippling-payroll-upload-v1';
export const ASC_COST_UPLOAD_TEMPLATE_KEY = 'asc-cost-upload-v1';
